
				var addMethods = require("../../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["setJwt","getJwt","refreshToken","checkNotifications","addTask"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "db59d9e50b3ceaf43290.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "db59d9e50b3ceaf43290.worker.js");
					addMethods(w, methods)
					
					return w
				}
			